<div class="web-console-restricted-wrapper">
  <mat-card class="web-console-restricted-card">
    <mat-card-title class="custom-card-title">{{ 'COMMON.WEB_CONSOLE_RESTRICTED_TITLE' | translate }}</mat-card-title>
    <p>{{ 'COMMON.WEB_CONSOLE_RESTRICTED_MESSAGE' | translate }}</p>
    <button type="button" (click)="logout()" mat-flat-button color="primary">{{ 'COMMON.LOGOUT' | translate }}</button>
  </mat-card>
</div>
